import React, { useEffect, useState } from 'react';
import BarChart from 'components/BarChart';
import Api from 'config/api';
import { Spin, notification, Empty } from 'antd';
import { makeStyles } from '@material-ui/styles';

export default function Cpi() {
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState([]);
  const classess = useStyles();
  useEffect(() => {
    getCpi();
  }, []);

  const getCpi = async () => {
    try {
      setLoading(true);
      const response = await Api.get('website/get-cpi');
      setData(response?.data?.data);
    } catch ({ message, state }) {
      notification.error('There was an error getting CPI.');
    }
    setLoading(false);
  };

  const requiredData = data.map((data) => {
    return {
      name: data.year,
      value: data.value,
      month: data.month,
    };
  });
  const months = [
    'Jan',
    'Feb',
    'Mar',
    'Apr',
    'May',
    'Jun',
    'Jul',
    'Aug',
    'Sep',
    'Oct',
    'Nov',
    'Dec',
  ];
  return (
    <Spin spinning={loading}>
      <div className={classess.container}>
        {!loading && data.length > 0 ? (
          <div className={classess.barCharWrap}>
            <BarChart
              data={requiredData.sort((a, b) => {
                if (a.name !== b.name) {
                  return a.name - b.name;
                } else {
                  //an issue from the backend certain months had spaces in their spelling
                  const monthA = a.month.replace(' ', '');
                  const monthB = b.month.replace(' ', '');
                  return months.indexOf(monthA) - months.indexOf(monthB);
                }
              })}
              valueType="number"
              isLoading={false}
              opposite={true}
            />
          </div>
        ) : (
          <div
            className="d-flex align-items-center justify-content-center"
            style={{ height: '300px', width: '100%' }}
          >
            <Empty />
          </div>
        )}
      </div>
    </Spin>
  );
}

const useStyles = makeStyles({
  container: {
    overflow: 'scroll',
  },
  barCharWrap: {
    minWidth: '935px',
  },
});
